import React from 'react';
import { Container, Typography, Grid } from '@mui/material';
import styles from '../../../../containers/about-us.module.scss';

const OurStory = ({ header, paragraphs }) => {
  return (
    <Container>
      <Grid
        container
        xs={12}
        sm={12}
        md={12}
        lg={12}
        className={styles['our-story-container']}
      >
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Typography variant='h5'>{header}</Typography>
        </Grid>
        <Grid>
          {paragraphs.map((paragraph, index) => (
            <Grid key={index} xs={12} sm={12} md={12} lg={12} paddingBottom='2rem'>
              <Typography variant='body2' sx={{ textAlign: 'left' }}>
                {paragraph}.
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Container>
  );
};

export default OurStory;
